export const shuffleArray = <T>(array: T[]): T[] => {
  const copiedArray = [...array];
  for (let counter = copiedArray.length - 1; counter > 0; counter -= 1) {
    const randomPosition = Math.floor(Math.random() * (counter + 1));
    [copiedArray[counter], copiedArray[randomPosition]] = [copiedArray[randomPosition], copiedArray[counter]];
  }
  return copiedArray;
};
